/**
 * @generated SignedSource<<0fae14a2241e15be35e665c2220ea863>>
 * @relayHash c77f53b35a81e814d039a78d8e2aedca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1bdd8cfa86ba824ded85a0754d83db9a4352165261a9717dd1e638a9ae45f71d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RecommendPremiumToStandardModalRendererQuery } from './RecommendPremiumToStandardModalRendererQuery.graphql';

const node: PreloadableConcreteRequest<RecommendPremiumToStandardModalRendererQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1bdd8cfa86ba824ded85a0754d83db9a4352165261a9717dd1e638a9ae45f71d",
    "metadata": {},
    "name": "RecommendPremiumToStandardModalRendererQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
